import { Button, Checkbox, Grid, Typography } from "@material-ui/core";
import { useState } from "react";
import { ServiceCompatiblePlacesEditor } from "..";
import {
  ServiceBuilding,
  ServiceCompatiblePlace,
  ServiceOverridableProps,
} from "../../../graphql/models";

export interface ServiceBuildingEditorProps {
  defaultOverridableProps: ServiceOverridableProps;
  building: ServiceBuilding;
  askCompatiblePlaces: boolean;
  onChange: (
    overridableProps: ServiceOverridableProps,
    compatiblePlaces?: ServiceCompatiblePlace[]
  ) => void;
}

export function ServiceBuildingEditor(props: ServiceBuildingEditorProps) {
  const { building, defaultOverridableProps, onChange, askCompatiblePlaces } =
    props;

  const [enabled, setEnabled] = useState(false);
  const [active, setActive] = useState(
    building.overrideProps?.active ?? defaultOverridableProps.active ?? true
  );
  const [displayInApp, setDisplayInApp] = useState(
    building.overrideProps?.displayInApp ??
      defaultOverridableProps.displayInApp ??
      true
  );
  const [compatiblePlaces, setCompatiblePlaces] = useState<
    ServiceCompatiblePlace[]
  >(building.compatiblePlaces ?? []);

  const triggerEditOrSave = () => {
    if (enabled) {
      setEnabled(false);
      onChange(
        {
          active,
          displayInApp,
        },
        compatiblePlaces
      );
    } else {
      setEnabled(true);
    }
  };

  return (
    <Grid container spacing={3}>
      <Grid item sm={4} xs={4}>
        Attivo?
        <Checkbox
          disabled={!enabled}
          checked={active}
          onChange={(_evt, checked) => setActive(!active)}
        />
      </Grid>
      <Grid item sm={4} xs={4}>
        Mostra in app?
        <Checkbox
          disabled={!enabled}
          checked={displayInApp}
          onChange={(_evt, checked) => setDisplayInApp(!displayInApp)}
        />
      </Grid>
      {askCompatiblePlaces && (
        <Grid item sm={12} xs={12}>
          <Typography variant="h4">Luoghi compatibili</Typography>
          <br />
          <ServiceCompatiblePlacesEditor
            disabled={!enabled}
            compatiblePlaces={compatiblePlaces}
            onCompatiblePlacesChange={(places) => setCompatiblePlaces(places)}
          />
        </Grid>
      )}

      <Grid item xs={12}>
        <Button onClick={triggerEditOrSave} color="secondary">
          {enabled ? "Conferma modifiche" : "Modifica"}
        </Button>
      </Grid>
    </Grid>
  );
}
